export default {
	checkEmail: "Vérifiez votre e-mail",
	checkSpam: "Vous ne le trouvez pas ? Vérifiez votre dossier de courrier indésirable.",
	error: "Erreur de vérification",
	goToLogin: "Aller à la connexion",
	invalidToken: "Jeton invalide ou expiré. Veuillez en demander un nouveau.",
	resend: "Renvoyer l'e-mail",
	resendSuccess: "E-mail renvoyé avec succès !",
	sentTo: "Nous avons envoyé un lien de vérification à {email}",
	success: "E-mail vérifié !",
	successDesc: "Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter.",
	verifying: "Vérification en cours...",
};
